<p-dialog
	[header]="header()"
	[(visible)]="visible"
	[modal]="true"
	[dismissableMask]="true"
	[style]="{ width: '520px', maxHeight: '80vh' }"
	appendTo="body"
	(onHide)="onHide()"
	(onShow)="onShow()"
>
	@if (sourceLabel()) {
		<div class="mb-2 text-[12px] text-wb-muted">
			Copying <span class="font-mono text-wb-text">{{ sourceLabel() }}</span> to:
		</div>
	}

	<div class="mb-3">
		<input
			#searchInput
			pInputText
			class="w-full"
			placeholder="Search chapters..."
			[ngModel]="searchQuery()"
			(ngModelChange)="searchQuery.set($event)"
		/>
	</div>

	<div class="copy-list">
		@for (option of filteredOptions(); track option.chapterSlug) {
			<button
				type="button"
				class="copy-item"
				[class.copy-item--selected]="isSelected(option.chapterSlug)"
				[attr.aria-pressed]="isSelected(option.chapterSlug)"
				(click)="selectTarget(option.chapterSlug)"
			>
				<i class="pi copy-item-icon" [class.pi-folder]="option.chapterSlug" [class.pi-home]="!option.chapterSlug"></i>
				<span class="copy-item-slug">{{ option.label }}</span>
				<span class="copy-item-meta">{{ option.sceneCount }} scenes &middot; {{ option.imageCount }} images</span>
				@if (isSelected(option.chapterSlug)) {
					<i class="pi pi-check copy-item-check"></i>
				}
			</button>
		}
		@if (filteredOptions().length === 0) {
			<div class="text-center py-8 text-wb-muted text-sm">No matching chapter</div>
		}
	</div>

	<div class="mt-3 flex items-center justify-end gap-2">
		<button pButton size="small" severity="secondary" [text]="true" (click)="cancel()">Cancel</button>
		<button pButton size="small" [disabled]="!selected()" (click)="confirm()"><i class="pi pi-copy"></i>Copy here</button>
	</div>
</p-dialog>
